module.exports = __webpack_public_path__ + "img/1502946955.7a27cb78.jpg";